import _ from 'lodash';
import moment from 'moment';
import {
  Firebase,
  getCurrentTimestamp,
  callIfFunction,
  accountId,
  organizationId,
  isProduction,
  isExport,
  omitDeleted,
  addKeysAsIds,
  unwrapDoc,
  unwrapDocs,
} from './../util';

import {
  AppConfigRef,
  AssessmentVersionsRef,
  AssessmentConfigsRef,
} from './../util/refs';

import {
  UPDATE_APP_CONFIG,
  UPDATE_APP_CONFIG_COMPLETE,

  FETCH_ASSESSMENT_VERSIONS,
  UPDATE_ASSESSMENT_VERSIONS,
  UPDATE_ASSESSMENT_VERSIONS_COMPLETE,
} from './types';

export function updateAppConfig(newProps, callback){
  return dispatch => {
    dispatch({ type: UPDATE_APP_CONFIG });

    AppConfigRef().update({
      ...newProps
    }).then(() => {
      dispatch({ type: UPDATE_APP_CONFIG_COMPLETE });
      callIfFunction(callback);
    });
  }
}

export function fetchAssessmentVersions(){
  return dispatch => {
    AssessmentVersionsRef().get().then(docs => {

      dispatch({
        type: FETCH_ASSESSMENT_VERSIONS,
        payload: unwrapDocs(docs)
      });
    });
  }
}

export function fetchAssessmentConfigs(callback){
  AssessmentConfigsRef().get().then(docs => {
    console.log('configs: ', unwrapDocs(docs));
    callback(unwrapDocs(docs));
  });
}

//TODO this needs to archive existing latest version
export function updateLatestAssessmentVersion(newVersionData, callback){
  return dispatch => {
    dispatch({ type: UPDATE_ASSESSMENT_VERSIONS });

    //first, get existing "latest" version
    AssessmentVersionsRef().doc('latest').get().then(doc => {
      const assessmentVersionForHistory = doc.data();

      //if NEW version...
      if(newVersionData.versionLabel !== assessmentVersionForHistory.versionLabel){
        //second, archive existing version
        AssessmentVersionsRef().doc((assessmentVersionForHistory || {}).versionLabel || 'deletethis').set(assessmentVersionForHistory || {initial: true}).then(() => {

          //third, overwrite latest version w/ new data
          AssessmentVersionsRef().doc('latest').set(newVersionData).then(() => {

            //lastly, refetch all assessment versions to ensure we have the latest data locally
            AssessmentVersionsRef().get().then(docs => {
              dispatch({
                payload: unwrapDocs(docs),
                type: UPDATE_ASSESSMENT_VERSIONS_COMPLETE
              });

              callIfFunction(callback);
            });
          });
        });
      }
      //if replacing latest version data
      else{
        AssessmentVersionsRef().doc('latest').set(newVersionData).then(() => {
          //lastly, refetch all assessment versions to ensure we have the latest data locally
          AssessmentVersionsRef().get().then(docs => {
            dispatch({
              payload: unwrapDocs(docs),
              type: UPDATE_ASSESSMENT_VERSIONS_COMPLETE
            });

            callIfFunction(callback);
          });
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/admin.js